(function (angular) {
    'use strict';

    angular.module('app')
        .service('SurveysAnswersApi', SurveysAnswersApi);

    SurveysAnswersApi.$inject = [
        '$resource',
        'settings',
        'extendResource',
    ];

    function SurveysAnswersApi(
        $resource,
        settings,
        extendResource,
    ) {
        const resource = $resource(settings.apiBase + '/surveys/:id/answers', {id: '@id'}, {
            answer: {
                method: 'POST',
                responseType: 'json',
                url: `${settings.apiBase}/surveys/:id/answers`,
            },
        });

        return extendResource(resource);
    }

}(angular));
